import { EquipmentForm } from './equipment-form.model';
import { CourseForm } from './course-form.model';

export class MailFormData {
  name: string;
  email: string;
  phone: string;
  message: string;
  equipment: EquipmentForm[];
  courses: CourseForm[];
  isSecurity = false;
  isEquipmentSell = false;
  isEquipmentRepair = false;
  isCourses = false;

  constructor(data: any) {
    Object.assign(this, data);
    console.log(this);
  }

  private getMailContent() {
    let template = `${this.message}\n\n- Teléfono: ${this.phone}`;

    if (this.isEquipmentRepair) {
      template = `${template}\n\nInterés en reparación de equipos:\n`;
    } else if (this.isEquipmentSell) {
      template = `${template}\n\nInterés en venta de equipos:\n`;
    }

    if (this.equipment && this.equipment[0].brand) {
      for (const e of this.equipment) {
        template = `${template}\n- Marca: ${e.brand}\n- Modelo: ${e.model}\n- Requerimientos técnicos: ${e.technicalRequirements}\n\n`;
      }
    }

    if (this.courses && this.courses[0].code) {
      template = `${template}\n\nInterés en cursos:`;
      for (const c of this.courses) {
        // tslint:disable-next-line: max-line-length
        template = `${template}\n- Código del curso: ${c.code}\n- Personas: ${c.people}\n- Ciudad: ${c.city}\n- Comentarios: ${c.comments}\n\n`;
      }
    }

    return template;
  }

  getMailMessage() {
    return {
      from: this.email,
      message: this.getMailContent(),
      // to: this.isSecurity ? 'ventas.sh@cccisa.com.mx' : 'ventas.calibracion@cccisa.com.mx',
      to: 'prueba@fraveit.mx',
      name: this.name
    };
  }
}
